import { actionTypes } from '../actions/types';

const initState = {
  isLoading: false,
  referrer: null,
  error: null,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case actionTypes.FETCH_REFERRER:
      return {
        ...state,
        isLoading: true,
        referrer: null,
        error: null,
      };
    case actionTypes.FETCHED_REFERRER:
      return {
        ...state,
        isLoading: false,
        referrer: action.data,
        error: null,
      };
    case actionTypes.REFERRER_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        referrer: null,
        error: true,
      };
    default:
      return state;
  }
};
